import Vue from 'vue';
import { mapActions } from 'vuex';
import { get } from 'lodash';
import { DEFAULT_THEME } from 'constants/themes';

import { triggerDataInserted } from 'framework/router/data-inserted-hook';

const $title = document.querySelector('head title');
const $description = document.querySelector('head meta[name=description]');

if (!$title || !$description) {
    console.warn(`Warning! Make sure that every page has exactly one title and one description!`);
}

const areRoutesDifferent = (from, to) => !Vue.$fetchRoute.compareRecords(from, to);

export default {
    created() {
        this.updateRouteData();

        this.$router.beforeEach((from, to, next) => {
            if (areRoutesDifferent(from, to)) {
                this.setPageLoading({ isLoading: true });
            }

            next();
        });

        this.$router.afterEach((from, to) => areRoutesDifferent(from, to) && this.updateRouteData());
    },
    methods: {
        ...mapActions('lateral-menu', {
            closeLareralMenu: 'close',
        }),
        ...mapActions('scroll', ['setScroll']),
        ...mapActions('page', ['setContainers', 'setLanguageSiblings', 'setPageLoading', 'setTheme']),
        onReceiveFetched(fetched = {}) {
            this.updateMeta(fetched.meta || {});
            this.setTheme({ theme: fetched.meta.theme || DEFAULT_THEME });
            this.setLanguageSiblings({ languageSiblings: fetched.meta.languages });
            this.setContainers({ containers: fetched.containers || {} });

            this.cleanUpPostFetch();

            this.setPageLoading({ isLoading: false });
        },
        onNetworkError(error) {
            // NOTE: Handle server error code (everything other than 200)
            throw error;
        },
        cleanUpPreFetch() {
            this.closeLareralMenu();
            // NOTE: Reset states, for example overlays that must be closed prior to navigation
        },
        cleanUpPostFetch() {
            // NOTE: Clean up after data was being inserted
            this.$nextTick(() => {
                triggerDataInserted();
                this.setScroll();
            });
        },
        updateMeta({ title, description }) {
            // NOTE: Update document descriptors on route change
            $title.text = title;
            $description.content = description;
        },

        updateRouteData() {
            if (get(this.$route, 'meta.api')) {
                const Fetched = Vue.$fetchRoute.invokeFetch(this.$route);
                this.cleanUpPreFetch();
                Fetched.then(this.onReceiveFetched, this.onNetworkError);
            } else {
                this.$log.warn('Apparently the current route has no data to fetch');
            }
        },
    },
};

